import { useLocationContext } from '_/hooks/LocationContext';
import DropdownButton from '../DropdownButton';
import { useTranslation } from 'react-i18next';
import CustomDropDownFieldValuesModal from '../ConfirmReserveModal/CustomDropDownFieldModal';
import { SpaceType } from '_/services/models/enums/space-type.enum';
import { CustomModalType } from '../ConfirmReserveModal/interface';

interface ICostCentersOptions {
  locationId: string;
  slotCostCenterEnabled: boolean;
  memberShowCustomFields: boolean;
  costCenter: string;
  setCostCenter: React.Dispatch<React.SetStateAction<string>>;
  customModalVisible: CustomModalType | undefined;
  setCustomModalVisible: React.Dispatch<React.SetStateAction<CustomModalType | undefined>>;
  spaceType: SpaceType;
}

const CostCentersOptions = ({
  locationId,
  slotCostCenterEnabled,
  memberShowCustomFields,
  costCenter,
  setCostCenter,
  customModalVisible,
  setCustomModalVisible,
  spaceType,
}: ICostCentersOptions) => {
  const { getCostCenterByLocationId } = useLocationContext();
  const { t } = useTranslation();
  const costCentersArray = getCostCenterByLocationId(locationId)?.costCenters ?? [];

  const showCostCenter =
    slotCostCenterEnabled && !!costCentersArray.length && memberShowCustomFields;

  return (
    <>
      {showCostCenter && (
        <DropdownButton
          text={costCenter || t('costCenter')}
          icon="dollar-sign"
          tag={costCenter && t('costCenter')}
          onPress={() => setCustomModalVisible('costCenter')}
        />
      )}
      {customModalVisible === 'costCenter' && (
        <CustomDropDownFieldValuesModal
          hideDropdown={() => setCustomModalVisible(undefined)}
          label={t('costCenter')}
          setDropdownField={setCostCenter}
          value={costCenter}
          options={costCentersArray}
          visible={customModalVisible === 'costCenter'}
          spaceType={spaceType}
        />
      )}
    </>
  );
};
export default CostCentersOptions;
